import { render, staticRenderFns } from "./GalleryThumbnailErrorOverlay.vue?vue&type=template&id=2ec4b852&scoped=true"
import script from "./GalleryThumbnailErrorOverlay.vue?vue&type=script&lang=ts"
export * from "./GalleryThumbnailErrorOverlay.vue?vue&type=script&lang=ts"
import style0 from "./GalleryThumbnailErrorOverlay.vue?vue&type=style&index=0&id=2ec4b852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec4b852",
  null
  
)

export default component.exports